var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"delete-transactions-header-main"},[_c('div',{staticClass:"header-title"},[_c('p',[_vm._v(_vm._s(_vm.$t("delete_transactions_panel.title")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }